export const DEFAULT_LOCATION = {
  name: "Islamabad",
  country: "Pakistan",
  lat: 33.6844,
  lon: 73.0479,
};
export const MODULE_IDS = ["air", "climate", "flood", "veg", "drought"];
export const FAVORITES_KEY = "airvista.favorites.v1";
export const FAVORITES_LIMIT = 12;
export const EXAMPLE_LOCATIONS = [
  DEFAULT_LOCATION,
  { name: "Karachi", country: "Pakistan", lat: 24.8607, lon: 67.0011 },
  { name: "Lahore", country: "Pakistan", lat: 31.5204, lon: 74.3587 },
  { name: "London", country: "United Kingdom", lat: 51.5074, lon: -0.1278 },
  { name: "New York", country: "United States", lat: 40.7128, lon: -74.006 },
  {
    name: "Dubai",
    country: "United Arab Emirates",
    lat: 25.2048,
    lon: 55.2708,
  },
  { name: "Lagos", country: "Nigeria", lat: 6.5244, lon: 3.3792 },
  { name: "Sydney", country: "Australia", lat: -33.8688, lon: 151.2093 },
];

export function cleanLabel(value) {
  return typeof value === "string"
    ? [...value]
        .filter(
          (character) =>
            character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127,
        )
        .join("")
        .trim()
        .slice(0, 100)
    : "";
}

export function normalizeLocation(value) {
  if (!value || typeof value !== "object") return null;
  const raw = [value.lat, value.lon];
  if (
    raw.some(
      (v) =>
        v === null ||
        v === undefined ||
        !["number", "string"].includes(typeof v) ||
        String(v).trim() === "",
    )
  )
    return null;
  const [lat, lon] = raw.map(Number);
  if (
    !Number.isFinite(lat) ||
    !Number.isFinite(lon) ||
    Math.abs(lat) > 90 ||
    Math.abs(lon) > 180
  )
    return null;
  return {
    lat,
    lon,
    name: cleanLabel(value.name) || "Selected location",
    country: cleanLabel(value.country),
  };
}

export function locationKey(location) {
  return `${location.lat.toFixed(4)},${location.lon.toFixed(4)}`;
}

export function monitorParams(location, module = "air") {
  const valid = normalizeLocation(location) || DEFAULT_LOCATION;
  const params = new URLSearchParams({
    lat: String(valid.lat),
    lon: String(valid.lon),
    name: valid.name,
    module: MODULE_IDS.includes(module) ? module : "air",
  });
  if (valid.country) params.set("country", valid.country);
  return params;
}

export function monitorPath(location, module = "air") {
  return `/monitor?${monitorParams(location, module)}`;
}

export function readMonitorParams(params) {
  const hasCoordinates = params.has("lat") || params.has("lon");
  const location = hasCoordinates
    ? normalizeLocation(Object.fromEntries(params))
    : DEFAULT_LOCATION;
  const module = params.get("module");
  return {
    location: location || DEFAULT_LOCATION,
    module: MODULE_IDS.includes(module) ? module : "air",
    warning:
      hasCoordinates && !location
        ? "This link has invalid coordinates. Showing Islamabad; search for another place below."
        : "",
  };
}

export function readFavorites() {
  try {
    const stored = JSON.parse(
      window.localStorage.getItem(FAVORITES_KEY) || "[]",
    );
    if (!Array.isArray(stored)) return [];
    const unique = new Map();
    stored.forEach((item) => {
      const valid = normalizeLocation(item);
      if (valid) unique.set(locationKey(valid), valid);
    });
    return [...unique.values()].slice(0, FAVORITES_LIMIT);
  } catch {
    return [];
  }
}
